// extracted by mini-css-extract-plugin
module.exports = {"formButton":"FormButton_formButton__22kiO"};